export const GET_LIST_OF_APPS = "GET_LIST_OF_APPS"
export const GET_PLAN_SPECIFICATION_DETAILS = "GET_PLAN_SPECIFICATION_DETAILS"
export const SET_LIST_OF_APPS = "SET_LIST_OF_APPS"
export const SET_PLAN_SPECIFICATION_DETAILS = "SET_PLAN_SPECIFICATION_DETAILS"
export const UPDATE_ACTIVE_MANAGE_APP = "UPDATE_ACTIVE_MANAGE_APP"
export const CLOSE_GET_STARTED_SECTION = 'CLOSE_GET_STARTED_SECTION'
export const SET_GET_STARTED_SECTION = 'SET_GET_STARTED_SECTION'
export const GET_TRANSACTION_LIMIT = 'GET_TRANSACTION_LIMIT'
export const SET_TRANSACTION_LIMIT = 'SET_TRANSACTION_LIMIT'



